<template>
  <div class="carousel-container">
    <vue-slick-carousel class="insights-carousel" :initialSlide="initialCarouselItemIndex" :per-page="1"
                        :arrows="false" :dots="true" :key="carouselItemCount" :dots-class="'my-slick-dots'"
                        @afterChange="onAfterChange">
      <insight-factory v-for="insight in sortedInsights" :key="insight._id" :insight="insight"/>
      <template #customPaging="pageIndex">
        <div class="dot" :class="pageIndex"></div>
      </template>
    </vue-slick-carousel>
  </div>
</template>

<script>
import Segment from '@/Segment';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

import { mapState, mapMutations, mapGetters } from 'vuex';
import InsightFactory from '../../insights/InsightFactory';

export default {
  name: 'InsightsCarousel',
  components: {
    InsightFactory,
    VueSlickCarousel,
  },
  computed: {
    ...mapState('insights', ['insights']),
    ...mapGetters('insights', ['sortedInsights']),
    carouselItemCount() {
      return this.insights.length;
    },
    finishedAllItems() {
      return this.carouselItemCount === 0;
    },
    initialCarouselItemIndex() {
      return this.carouselItemCount - 1;
    },
  },
  created() {
    this.sendEventCarouselItemReached(this.initialCarouselItemIndex);
  },
  methods: {
    ...mapMutations('applicationState', ['setNotificationState']),
    onAfterChange(slideIndex) {
      this.sendEventCarouselItemReached(slideIndex);
    },
    sendEventCarouselItemReached(slideIndex) {
      Segment.trackUserInteraction(`${this.insights[slideIndex].insightName}_InsightReachedInCarousel`);
    },
  },
  watch: {
    finishedAllItems(finished) {
      if (finished) {
        this.setNotificationState(null);
      }
    },
  },
};
</script>

<!-- This isn't scoped because we need to override some of the internal carousel styles -->
<style lang="scss">
@import '~base-ui/src/scss/riseup-colors';

.carousel-container {
  background-color: $riseup_gray_-1;
  padding-bottom: 15px;

  .my-slick-dots {
    width: 100%;
    padding: 0;
    list-style: none;
    text-align: center;
    li {
      margin: 0 7px;
      position: relative;
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: $riseup_gray_0;
      transition: background-color 0.2s;
      cursor: pointer;
      &.slick-active {
        background-color: $riseup_blue;
      }
    }
  }
}
</style>
